import React from 'react'
import { Typography } from '@sureco/design-system'

/**
 * Inert placeholder for a collapsible section whose functionality hasn't
 * shipped yet (Pause Enrollments — EMS-9955/9956, Activity — not yet
 * scoped). Keeps the section present in the UI, matching the design, without
 * implying it does anything today.
 */
export default function ComingSoonPanel({ message }: { message: string }) {
  return (
    <Typography size={14} color="secondary" style={{ padding: '8px 0' }}>
      {message}
    </Typography>
  )
}
